import React from 'react';
import { Button, Grid, Typography } from '@material-ui/core';
import IntlMessages from 'util/IntlMessages';

const classes = {
  circle_1: {
    position: 'absolute',
    width: '940px',
    height: '956px',
    left: '832px',
    top: '633px',
    background: 'var(--kea-color-primary)',
    borderRadius: '50%',
    zIndex: 0,
  },
  circle_2: {
    boxSizing: 'border-box',
    position: 'absolute',
    width: '1407.16px',
    height: '1425.47px',
    left: '179.83px',
    top: '-535px',
    background: '#FFFFFF',
    border: '1px solid var(--kea-color-primary-soft)',
    transform: 'matrix(0.9, 0.43, -0.4, 0.91, 0, 0)',
    borderRadius: '50%',
    zIndex: 1,
  },
  circle_3: {
    boxSizing: 'border-box',
    position: 'absolute',
    width: '1407.16px',
    height: '1435.47px',
    left: '233.81px',
    top: '-509.25px',
    border: '1px solid var(--kea-color-primary-soft)',
    transform: 'matrix(0.9, 0.43, -0.4, 0.91, 0, 0)',
    borderRadius: '50%',
    zIndex: 2,
  },
};

const OnboardingPageSupport = () => {
  const openLiveChat = () => {
    const { Chatra } = window;
    if (Chatra) {
      Chatra('openChat', true);
    }
  };
  return (
    <Grid container justifyContent="center" alignItems="center" style={{ height: '80vh' }}>
      <div style={{ position: 'static', zIndex: -1 }}>
        <div style={classes.circle_1} />
        <div style={classes.circle_2} />
        <div style={classes.circle_3} />
      </div>
      <div>
        <Typography variant="h4" component="h2" gutterBottom>
          <IntlMessages id="ui.setupVisualRecs.onboardingPageSupport.generationStartedStayInTouch" />
        </Typography>
        <Typography variant="h6" component="h3" gutterBottom>
          <IntlMessages id="ui.setupVisualRecs.onboardingPageSupport.getTheMostOutOfOurExpertSupport" />
        </Typography>

        <br />
        <br />
        <Typography variant="body1" align="center" gutterBottom>
          <IntlMessages id="ui.setupVisualRecs.onboardingPageSupport.whileYouCanDoAllTheIntegrationStepsOnYour" />
          <b>{' '}<IntlMessages id="ui.setupVisualRecs.onboardingPageSupport.contactUsViaEmailOrLiveChat" /></b>
        </Typography>
        <Typography variant="body1" align="center" paragraph>
          <IntlMessages id="ui.setupVisualRecs.onboardingPageSupport.letOurTeamProvide" />
          <b>{' '}<IntlMessages id="ui.setupVisualRecs.onboardingPageSupport.freeIntegrationSupport" />{' '}</b>
          <IntlMessages id="ui.setupVisualRecs.onboardingPageSupport.andConfigureTheSolutionToMeetYourStoreSUniqueRequirements" />
        </Typography>
        <br />
        <br />
        <br />
        <br />
        <br />
        <Button variant="contained" color="primary" onClick={openLiveChat}>
          <IntlMessages id="ui.setupVisualRecs.onboardingPageSupport.openLiveChat" />
        </Button>
      </div>
    </Grid>
  );
};

export default OnboardingPageSupport;
